if (!customElements.get('pw-size-links')) {
  customElements.define('pw-size-links', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const normalize = value => String(value || '').toLowerCase().replace(/^new-/, '').trim();
      const links = [...this.querySelectorAll('[data-size-variants]')].map(link => ({link, variants: JSON.parse(link.dataset.sizeVariants)}));
      const update = value => {
        const color = normalize(value);
        links.forEach(({link, variants}) => {
          const match = variants.find(variant => normalize(variant.color) === color);
          link.href = match ? match.url : link.dataset.sizeFallback;
        });
      };
      update(this.dataset.currentColor);
      this.scope = this.closest('[id^="MainProduct-"]');
      this.onColorChange = event => {
        if (event.target.name === 'Color' || event.target.name === 'options[Color]') update(event.target.value);
      };
      this.scope?.addEventListener('change', this.onColorChange);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onColorChange);
      this.initialized = false;
    }
  });
}
